/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-set-scale-start-dialog',
  templateUrl: './set-scale-start-dialog.component.html'
})
export class SetScaleStartDialogComponent {
  
  @Output()
  ok = new EventEmitter<boolean>();
  
  mId = 'setScaleStartDialog';
  mDialogHeaderId = 'setScaleStartHeader';
  
  
  show(): void {
    console.log("show()");
    $(`#${this.mId}`).modal("show");
  }
  
  hide(): void {
    console.log("hide()");
    $(`#${this.mId}`).modal("hide");
  }
  
  okClicked(): void {
    console.log("okClicked()");
    this.ok.emit(true);
    this.hide();
  }
  
}
